<template>
  <BaseField
    ref="field"
    v-bind="attributes"
    v-on="$listeners"
  />
</template>

<script>
import CONSTANTS from '@/helpers/constants';
import BaseField from '@/components/BaseField.vue';

export default {
  name: 'FieldAccount',
  inheritAttrs: false,
  components: {
    BaseField,
  },
  staticData: () => ({
    mask: {
      mask: new Array(CONSTANTS.ACCOUNT_FIELD_LENGTH).fill(0).join(''),
    },
  }),
  computed: {
    // placeholder() {
    //   if (!this.$attrs.value) return this.$t('fields.accountСodePlaceholder');
    //   const postfix = new Array(CONSTANTS.ACCOUNT_FIELD_LENGTH)
    //     .fill('_')
    //     .join('')
    //     .substring(this.$attrs.value.length);
    //   return this.$attrs.value + postfix;
    // },
    attributes() {
      return {
        type: 'tel', // при number маска работает некорректно (пропускает символы -.e)
        label: this.$t('fields.accountСodeLabel'),
        // inputPlaceholder: this.placeholder,
        placeholder: this.$t('fields.accountСodePlaceholder'),
        errorMessage: this.$t('fields.accountСodeError', {
          length: CONSTANTS.ACCOUNT_FIELD_LENGTH,
        }),
        // maskOptions: this.mask,
        required: true,
        ...this.$attrs,
      };
    },
  },
  methods: {
    focus() {
      return this.$refs.field?.focus();
    },
    checkValidity() {
      return this.$refs.field?.checkValidity();
    },
    checkHasValue() {
      return this.$refs.field?.checkHasValue();
    },
  },
};
</script>
